var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flexCarousel"},[_c('div',{staticClass:"LySlider"},[_c('div',{staticClass:"lyInner",style:({width: `${_vm.item.contents.length * (
      _vm.size ===  'LyGi' ? 507
      :_vm.size === 'LyMe' ? 307
      :_vm.size === 'LyKi' ? 267
      :_vm.size === 'LyHe' ? 248
      :_vm.size === 'LyDe' ? 227
      :_vm.size === 'LyMi' ? 167
      :_vm.size === 'LyNa' ? 127 : 'auto'
    )}px`})},[_vm._l((_vm.item.contents),function(bubble,b){return _vm._t("default",null,{"index":b,"bubble":bubble})})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }